import { Term } from "Interfaces/BookResort";
import { OwnerInfoRecord } from "Interfaces/OwnerInfo";

export enum Actions {
    SETDATA = 'SETDATA',
    ADDEMPTYCONTRACT = 'ADDEMPTYCONTRACT',
    ADDCONTRACTWITHDATA = 'ADDCONTRACTWITHDATA',
    DELETECONTRACT = 'DELETECONTRACT',
    ADDRECIPIENTDATA = 'ADDRECIPIENTDATA',
    ADDEMAIL = 'ADDEMAIL',
    ERROR = 'ERROR',
    TERMSANDCONDITION = 'TERMSANDCONDITION',
    TOGGLEMODAL = 'TOGGLEMODAL',
    ADDINPUTERROR = 'ADDINPUTERROR',
    TOGGLEINPUTERROR = 'TOGGLEINPUTERROR',
    TOGGLERECIPIENTINFOERROR = 'TOGGLERECIPIENTINFOERROR'
}

export type TransferPointAction = {
    type: Actions;
    payload: any;
}


export enum PageErrorType {
    'lastContractEmpty' = 'lastContractEmpty',
    'apiError' = 'apiError',
    'duplicateContract' = 'duplicateContract',
    'emailError' = 'emailError',
    'apiSubmitError' = 'apiSubmitError',
    'contractIdInputError' = 'contractIdInputError',
    'usageYearInputError' = 'usageYearInputError',
    'usageTypeInputError' = 'usageTypeInputError',
    'pointsInputError' = 'pointsInputError',
    'reipientFirstNameInputError' = 'firstNameInputError',
    'reipientLastNameInputError' = 'lastNameInputError',
    'reipientOwnerNumberInputError' = 'ownerNumberInputError',
    'reipientContractIdInputError' = 'reipientContractIdInputError',
    'termsError' = 'termsError',
    'additionalEmailError' = 'additionalEmailError',
    'selectedContractsEmpty' = 'selectedContractsEmpty',
    'transferPointError' = 'transferPointError',
    twentyThousandError = "twentyThousandError",
    "contractsPageError" = "contractsPageError",
    "twentyThousandPerUsageYearError" = "twentyThousandPerUsageYearError",
    "pointLimitError" = "pointLimitError",
    "pointsError" = "pointsError",
    "zeroPoints" = "zeroPoints",
    "noUsageTypePoints"= "noUsageTypePoints",
    "availablePointsPerContractError" = "availablePointsPerContractError"
}

export interface PageErrors {
    [PageErrorType.lastContractEmpty]: {
        message: string;
        isErrored: boolean;
    },
    [PageErrorType.apiError]: {
        message: string;
        isErrored: boolean;
    },
    [PageErrorType.duplicateContract]: {
        message: string;
        isErrored: boolean;
    },
    [PageErrorType.emailError]: {
        message: string;
        isErrored: boolean;
    },
    [PageErrorType.apiSubmitError]: {
        message: string;
        isErrored: boolean;
    },
}

export interface ReipientInformationErrors {
    [PageErrorType.reipientFirstNameInputError]: {
        message: string;
        isErrored: boolean;
    },
    [PageErrorType.reipientLastNameInputError]: {
        message: string;
        isErrored: boolean;
    },
    [PageErrorType.reipientOwnerNumberInputError]: {
        message: string;
        isErrored: boolean;
    },
    [PageErrorType.reipientContractIdInputError]: {
        message: string;
        isErrored: boolean;
    },
    [PageErrorType.termsError]: {
        message: string;
        isErrored: boolean;
    },
    [PageErrorType.additionalEmailError]: {
        message: string;
        isErrored: boolean;
    },
    [PageErrorType.selectedContractsEmpty]: {
        message: string;
        isErrored: boolean;
    },
    [PageErrorType.transferPointError]: {
        message: string;
        isErrored: boolean;
    },
    [PageErrorType.contractsPageError]: {
        message: string;
        isErrored: boolean;
    },
    [PageErrorType.twentyThousandPerUsageYearError]: {
        message: string;
        isErrored: boolean;
    },
    [PageErrorType.availablePointsPerContractError]: {
        message: string;
        isErrored: boolean;
    }
}

export type Contract = {
    contractNumber: string;
    contractID: number;
    usageYear: number;
    usageType: string;
    pointsAllocated: number;
    pointsRemaining: number;
    contractInfo: string;
    isValidforTransferPoints: boolean;
}

export type SelectedContract = {
    contractId: string;
    usageYear: number;
    usageType: string;
    numberofPointsToTransfer: number;
    inputErrors: inputErrors;
}

export type TransferPointsState = {
    contracts: Contract[];
    ownerInfo: OwnerInfoRecord;
    isloading: boolean;
    pageErrors: PageErrors;
    selectedContracts: SelectedContract[];
    recipientInformation: ReciepientInformation;
    additionalEmail: string;
    terms: Term[];
    recipientErrors: ReipientInformationErrors;
}

export interface ReciepientInformation {
    "firstName": string;
    "lastName": string;
    "ownerNumber": string;
    "contractId": string;
}

export interface TransferPointRequest {
    email: string;
    additionalEmail: string;
    phone: string;
    recipient: ReciepientInformation;
    contracts: any;
    preferredLanguage?: string;
    clubType?: string;
    country?: string;
    ORLCd?: string;
    loggedInOwnerID?: string;
    loggedInName?: string;
}

export interface TransferPointResponse {
    success: string;
    requestId: string;
}

export interface inputErrors {
    [PageErrorType.contractIdInputError]: {
        message: string;
        isErrored: boolean;
    },
    [PageErrorType.usageYearInputError]: {
        message: string;
        isErrored: boolean;
    },
    [PageErrorType.usageTypeInputError]: {
        message: string;
        isErrored: boolean;
    },
    [PageErrorType.pointsInputError]: {
        message: string;
        isErrored: boolean;
    },
    [PageErrorType.twentyThousandError]: {
        message: string,
        isErrored: boolean;
    },
    [PageErrorType.pointLimitError]: {
        message: string,
        isErrored: boolean;
    },
    [PageErrorType.pointsError]: {
        message: string,
        isErrored: boolean
    },
    [PageErrorType.zeroPoints]: {
        message: string;
        isErrored: boolean;
    },
    [PageErrorType.noUsageTypePoints]: {
        message: string;
        isErrored: boolean;
    }
}